module.exports = __webpack_public_path__ + "img/legato_dark_brown1.8efc78fb.jpg";